import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// One question in a form the member fills in: "1. Question text *", optional help line,
// the control (chips, text field, upload…) and an error line under it.
// Questions follow each other with a hairline between them.
export default function GrFormQuestion({
  number,
  label,
  required = false,
  help,
  error,
  htmlFor,
  id,
  children,
  sx,
}) {
  return (
    <Box
      id={id}
      sx={{
        py: gr.space[5],
        "&:first-of-type": { pt: 0 },
        "&:last-of-type": { pb: 0 },
        "& + &": { borderTop: `1px solid ${gr.color.line2}` },
        ...sx,
      }}
    >
      <Box
        component={htmlFor ? "label" : "p"}
        htmlFor={htmlFor}
        sx={{
          display: "flex",
          gap: gr.space[2],
          m: 0,
          fontFamily: gr.font.family,
          fontSize: gr.font.size.md,
          fontWeight: gr.font.weight.semibold,
          lineHeight: gr.font.lineHeight.normal,
          color: gr.color.ink,
        }}
      >
        {number != null ? (
          <Box component="span" sx={{ color: gr.color.muted, flex: "none" }}>
            {number}.
          </Box>
        ) : null}
        <Box component="span" sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
          {label}
          {required ? (
            <Box component="span" aria-label="required" sx={{ color: gr.color.danger, ml: gr.space[1] }}>
              *
            </Box>
          ) : null}
        </Box>
      </Box>
      {help ? (
        <Box
          component="p"
          sx={{ m: 0, mt: gr.space[1], fontSize: gr.font.size.sm, color: gr.color.ink2 }}
        >
          {help}
        </Box>
      ) : null}
      <Box sx={{ mt: gr.space[3] }}>{children}</Box>
      {error ? (
        <Box
          component="p"
          role="alert"
          sx={{ m: 0, mt: gr.space[2], fontSize: gr.font.size.xs, color: gr.color.danger }}
        >
          {error}
        </Box>
      ) : null}
    </Box>
  );
}

GrFormQuestion.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.node.isRequired,
  required: PropTypes.bool,
  help: PropTypes.node,
  error: PropTypes.node,
  htmlFor: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
};
